// const NotFound = () => import('../../components/Error/404')
const Login = () => import('../../components/Auth/Login')
const PasswordRecovery = () => import('../../components/Auth/PasswordRecovery')
const GCELanding = () => import('../../components/Front/GCELanding')
const GCERegistration = () => import('../../components/Auth/GCE/GCERegistration')
const GCELogin = () => import( '../../components/Auth/GCE/GCELogin.vue')
const HomePage = () => import('../../components/Front/HomePage')
const TestHomePage = () => import('../../components/Front/TestHomePage')
const Prospectus = () => import('../../components/Front/Prospectus')
const ApplicationProcess = () => import('../../components/Front/ApplicationProcess')
const AdmissionCircular = () => import('../../components/Front/AdmissionCircular')
const Schedule = () => import('../../components/Front/Schedule')
const Notice = () => import('../../components/Front/Notice')
const NoticeDetails = () => import('../../components/Front/NoticeDetails')
const FeePaymentRules = () => import('../../components/Front/FeePaymentRules')
const Profile = () => import('../../components/Front/Profile')
const RocketCallback = () => import('../../components/Front/RocketCallback')
const BkashCallback = () => import('../../components/Front/BkashCallback')
const Complain = () => import('../../components/Front/Complain')
const BkashGCECallback = () => import('../../components/Front/BkashGCECallback')
const GCERocketCallback = () => import('../../components/Front/GCERocketCallback.vue')

//const Launch = () => import('../../components/Front/Launch')
const ResultInaugural = () => import('../../components/Front/ResultInaugural')

const GCEGuideline = () => import('../../components/Front/GCEGuideline')
const GCEApplicationPortal = () => import('../../components/Front/GCEApplicationPortal')
const AdmissionTestResult = () => import('../../components/Front/AdmissionTestResult')
const GeneralQualifications = () => import('../../components/Front/GeneralQualifications')
const ThematicQualifications = () => import('../../components/Front/ThematicQualifications')
const SeatPlan = () => import('../../components/Front/SeatPlan')
const AdmissionNotice = () => import('../../components/Front/NoticePdf')

const AdmitCard = () => import('../../components/Front/AdmitCard')
const CheckAdmitCard = () => import('../../components/Front/CheckAdmitCard')

const Result = () => import('../../components/Front/Result')
const CheckExamResult = () => import('../../components/Front/CheckExamResult')

const SubjectChoice = () => import('../../components/Front/SubjectChoice')
const CheckSubjectChoice = () => import('../../components/Front/CheckSubjectChoice')

const PrintSIF = () => import('../../components/Front/PrintSIF')
//const CheckSIF = () => import('../../components/Front/CheckSIF')

const BankSlip = () => import('../../components/Front/BankSlip')

const Navbar = () => import('../../components/Partial/Navbar')
const Footer = () => import('../../components/Partial/Footer.vue')

const frontendRoutes = [
  /*{
     path: '*',
     name: '404',
     component: NotFound,
     meta: {
       basic: true,
       title: '404 Not Found'
     }
  },*/
  {
    path: '/',
    name: 'home',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: HomePage
    },
    meta: {
      basic: true,
      title: process.env.VUE_APP_NAME
    }
  },
  {
    path: '/test-home',
    name: 'test-home',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: TestHomePage
    },
    meta: {
      basic: true,
      title: 'Beta Testing - CU Admission Portal'
    }
  },
  {
    path: '/prospectus',
    name: 'prospectus',
    components: {
      navbar: Navbar,
      footer: Footer,
      // latestNews: LatestNews,
      default: Prospectus
    },
    meta: {
      basic: true,
      title: 'Prospectus - CU Admission Portal'
    }
  },
  {
    path: '/complain',
    name: 'complain',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: Complain
    },
    meta: {
      basic: true,
      title: 'Complain Box - CU Admission Portal'
    }
  },
  {
    path: '/admission-test-result',
    name: 'AdmissionTestResult',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: AdmissionTestResult
    },
    meta: {
      basic: true,
      title: 'Exam Result - CU Admission Portal'
    }
  },
  {
    path: '/general-qualifications',
    name: 'GeneralQualifications',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: GeneralQualifications
    },
    meta: {
      basic: true,
      title: 'General Qualifications - CU Admission Portal'
    }
  },
  {
    path: '/admission-notice',
    name: 'AdmissionNotice',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: AdmissionNotice
    },
    meta: {
      basic: true,
      title: 'Notice - CU Admission Portal'
    }
  },
  {
    path: '/seat-plan',
    name: 'SeatPlan',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: SeatPlan
    },
    meta: {
      basic: true,
      title: 'Seat Plan - CU Admission Portal'
    }
  },
  {
    path: '/thematic-qualifications',
    name: 'ThematicQualifications',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: ThematicQualifications
    },
    meta: {
      basic: true,
      title: 'Thematic Qualifications - CU Admission Portal'
    }
  },
  {
    path: '/gce',
    name: 'gcelanding',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: GCELanding
    },
    meta: {
      basic: true,
      title: 'Guideline Applications - CU Admission Portal'
    }
  },
  {
    path: '/gce-guideline',
    name: 'gceguideline',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: GCEGuideline
    },
    meta: {
      basic: true,
      title: 'Guideline - CU Admission Portal'
    }
  },
  {
    path: '/gce/registration',
    name: 'gceregistration',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: GCERegistration
    },
    meta: {
      basic: true,
      title: 'GCE Registration - CU Admission Portal'
    }
  },
  {
    path: '/gce/login',
    name: 'gcelogin',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: GCELogin
    },
    meta: {
      basic: true,
      title: 'GCE Login - CU Admission Portal'
    }
  },
  {
    path: '/gce/dashboard',
    name: 'gcedashboard',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: GCEApplicationPortal
    },
    meta: {
      gceAuth: true,
      title: 'GCE Application Dashboard - CU Admission Portal'
    }
  },
  {
    path: '/notice',
    name: 'notice',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: Notice
    },
    meta: {
      basic: true,
      title: 'Notice - CU Admission Portal'
    }
  },
  {
    path: '/notice-details/:id',
    name: 'notice-details',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: NoticeDetails
    },
    meta: {
      basic: true,
      title: 'Notice Details - CU Admission Portal'
    }
  },
  {
    path: '/application-process',
    name: 'application-process',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: ApplicationProcess
    },
    meta: {
      basic: true,
      title: 'Application Process - CU Admission Portal'
    }
  },
  {
    path: '/admission-circular',
    name: 'admission-circular',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: AdmissionCircular
    },
    meta: {
      basic: true,
      title: 'Admission Circular - CU Admission Portal'
    }
  },
  {
    path: '/schedule',
    name: 'schedule',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: Schedule
    },
    meta: {
      basic: true,
      title: 'Schedule - CU Admission Portal'
    }
  },
  {
    path: '/admit-card/:unit',
    name: 'admit-card',
    components: {
      default: AdmitCard
    },
    meta: {
      basic: true,
      /*auth: true,*/
      title: 'Admit Card - CU Admission Portal'
    }
  },
  {
    path: '/check-admit-card/:hash',
    name: 'check-admit-card',
    components: {
      default: CheckAdmitCard
    },
    meta: {
      /*basic: true,
      auth: false,*/
      guest: true,
      title: 'Check Admit Card - CU Admission Portal'
    }
  },
  {
    path: '/result/:unit/:quota',
    name: 'result',
    components: {
      default: Result
    },
    meta: {
      auth: true,
      title: 'Result - CU Admission Portal'
    }
  },
  {
    path: '/check-exam-result/:hash',
    name: 'check-exam-result',
    components: {
      default: CheckExamResult
    },
    meta: {
      /*basic: true,
      auth: false,*/
      guest: true,
      title: 'Check Admission Test Result - CU Admission Portal'
    }
  },
  {
    path: '/subjects/:unit/:quota',
    name: 'subjects',
    components: {
      default: SubjectChoice
    },
    meta: {
      auth: true,
      title: 'Subject Choice - CU Admission Portal'
    }
  },
  {
    path: '/check-subject-choice/:hash',
    name: 'check-subject-choice',
    components: {
      default: CheckSubjectChoice
    },
    meta: {
      /*basic: true,
      auth: false,*/
      guest: true,
      title: 'Check Subject Selection - CU Admission Portal'
    }
  },
  /*{
    path: '/launch',
    name: 'launch',
    components: {
      default: Launch
    },
    meta: {
      guest: true,
      title: 'Application Inauguration - CU Admission Portal'
    }
  },*/
  {
    path: '/resultInauguration',
    name: 'resultInauguration',
    components: {
      default: ResultInaugural
    },
    meta: {
      basic: true,
      title: 'Result Inauguration - CU Admission Portal'
    }
  },
  {
    path: '/check-sif/:hash_key',
    name: 'check-sif',
    components: {
      default: PrintSIF
    },
    meta: {
      basic: true,
      title: 'Check SIF - CU Admission Portal'
    }
  },
  {
    path: '/print-sif',
    name: 'print-sif',
    components: {
      default: PrintSIF
    },
    meta: {
      auth: true,
      title: 'Print SIF - CU Admission Portal'
    }
  },
  {
    path: '/bank-slip',
    name: 'bank-slip',
    components: {
      default: BankSlip
    },
    meta: {
      auth: true,
      title: 'Bank Slip - CU Admission Portal'
    }
  },
  {
    path: '/fee-payment-rules',
    name: 'fee-payment-rules',
    components: {
      navbar: Navbar,
      footer: Footer,
      default: FeePaymentRules
    },
    meta: {
      basic: true,
      title: 'Fee Payment Rules - CU Admission Portal'
    }
  },
  {
    path: '/profile',
    name: 'profile',
    components: {
      navbar: Navbar,
      default: Profile
    },
    meta: {
      auth: true,
      title: 'Profile - CU Admission Portal'
    }
  },
  {
    path: '/profile/rocket-callback',
    name: 'rocket-callback',
    components: {
      default: RocketCallback
    },
    meta: {
      auth: true,
      title: 'Processing Payment - CU Admission Portal'
    }
  },
  {
    path: '/gce/dashboard/rocket-callback',
    name: 'gce-rocket-callback',
    components: {
      default: GCERocketCallback
    },
    meta: {
      gceAuth: true,
      title: 'Processing Payment - CU Admission Portal'
    }
  },
  {
    path: '/gce/dashboard/bkash-callback',
    name: 'gce-bkash-callback',
    components: {
      default: BkashGCECallback
    },
    meta: {
      gceAuth: true,
      title: 'GCE Processing Payment - CU Admission Portal'
    }
  },
  {
    path: '/profile/bkash-callback',
    name: 'bkash-callback',
    components: {
      default: BkashCallback
    },
    meta: {
      auth: true,
      title: 'Processing Payment - CU Admission Portal'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    components: {
      navbar: Navbar,
      default: Login,
      footer: Footer,
    },
    meta: {
      guest: true,
      title: 'Login - CU Admission Portal'
    }
  },
  {
    path: '/password-recovery',
    name: 'password-recovery',
    components: {
      navbar: Navbar,
      default: PasswordRecovery,
      footer: Footer
    },
    meta: {
      guest: true,
      title: 'Forgot Password - CU Admission Portal'
    }
  },
]
export default frontendRoutes
